import { render, staticRenderFns } from "./view1.vue?vue&type=template&id=919cbf80&scoped=true"
import script from "./view1.vue?vue&type=script&lang=js"
export * from "./view1.vue?vue&type=script&lang=js"
import style0 from "./view1.vue?vue&type=style&index=0&id=919cbf80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919cbf80",
  null
  
)

export default component.exports